import React from 'react';

const TypographyPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default TypographyPage;
